import React, { createContext, useContext, useState, ReactNode } from 'react';
import { getRecentProjects, addProjectToRecent, ProjectInfo } from '../utils/localStorageUtils';
import { useGlobalContext } from './GlobalContext';

interface ProjectContextType {
  recentProjects: ProjectInfo[];
  refreshRecentProjects: () => void;
  openProject: () => Promise<void>;
  openRecentProject: (path: string) => void;
}

const ProjectContext = createContext<ProjectContextType | undefined>(undefined);

export const ProjectProvider = ({ children }: { children: ReactNode }) => {

  const {
        setProjectRootPathAndProjectName,
        setCurrentDirectory
    } = useGlobalContext();
  
  const [recentProjects, setRecentProjects] = useState<ProjectInfo[]>(getRecentProjects());
  

  const refreshRecentProjects = () => {
    setRecentProjects(getRecentProjects());
  };


  const openProject = async () => {
    const result = await window.electron.ipcRenderer.invoke('select-folder');
    if (result?.success) {
      setProjectRootPathAndProjectName(result.path);
      addProjectToRecent(result.path);
      refreshRecentProjects();
      setCurrentDirectory(result.path);
    }
  };

  const openRecentProject = (path: string) => {
    setProjectRootPathAndProjectName(path);
    addProjectToRecent(path);
    refreshRecentProjects();
    setCurrentDirectory(path);
  };

  return (
    <ProjectContext.Provider value={{
      recentProjects,
      refreshRecentProjects,

      openProject,
      openRecentProject
    }}>
      {children}
    </ProjectContext.Provider>
  );
};

export const useProject = (): ProjectContextType => {
  const ctx = useContext(ProjectContext);
  if (!ctx) throw new Error('useProject must be used within a ProjectProvider');
  return ctx;
};